import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState: StateSliceType = {
  states: { count: 0, result: [] },
};

export const stateSlice = createSlice({
  name: "states",
  initialState,
  reducers: {
    setStates: (
      state: StateSliceType,
      action: PayloadAction<PaginatedResonse<StateType>>
    ) => {
      state.states = action.payload;
    },
  },
});

export const { setStates } = stateSlice.actions;
export default stateSlice.reducer;
